import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { clusterDetails, compareView } from '../../data/snak';
import { clusters } from '../../data/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ClusterCompareOverlayProps {
  onClose: () => void;
}
export function ClusterCompareOverlay({
  onClose
}: ClusterCompareOverlayProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.18,
    ease: EASE
  }} className="fixed inset-0 z-40 flex items-center justify-center bg-ink/70 px-6 py-8" role="dialog" aria-modal="true" aria-label={compareView.headline} data-id="element-70" data-mp="37mdge755dhri">
      <motion.div initial={{
      opacity: 0,
      y: 10,
      scale: 0.98
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.98
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="flex max-h-full w-full max-w-[1080px] flex-col overflow-hidden rounded-[28px] bg-paper shadow-soft" data-id="element-71" data-mp="3lbyub343b6so">
        <div className="flex items-center justify-between gap-6 bg-navy px-9 py-5" data-id="element-72" data-mp="3ltbw8rjo0yps">
          <div data-id="element-73" data-mp="3lvg7xvnt320m">
            <p className="flex items-center gap-2.5 text-[10px] uppercase tracking-micro text-mint" data-id="element-74" data-mp="3hrqr5sddhoq5">
              <span className="h-1.5 w-1.5 rounded-full bg-mint" aria-hidden="true" data-id="element-75" data-mp="3csnlq6thdghn" />
              {compareView.eyebrow}
            </p>
            <h2 className="mt-2 font-display text-[22px] font-semibold leading-snug tracking-tight text-paper" data-id="element-76" data-mp="dch4o88bj0r0">
              {compareView.headline}
            </h2>
          </div>
          <button type="button" onClick={onClose} className="flex h-10 shrink-0 items-center gap-2 rounded-full border border-sky/25 px-4 text-[12.5px] font-medium text-sky/80 transition-colors duration-150 hover:border-mint/50 hover:text-mint focus:outline-none focus-visible:ring-2 focus-visible:ring-mint" data-id="element-77" data-mp="4kp0ugdsupve">
            <ArrowLeftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-78" data-mp="s8q4baw4fg3y" />
            {compareView.cta}
          </button>
        </div>

        <div className="grid flex-1 grid-cols-4 gap-px overflow-y-auto bg-line" data-id="element-79" data-mp="1g6nztdz61psi">
          {clusters.map((cluster, i) => {
          const detail = clusterDetails.find(d => d.id === cluster.id);
          return <section key={cluster.id} className="flex flex-col bg-paper" data-id="element-80" data-mp="16f9wev43g5u3" data-mpi={i}>
                <div className="relative h-44 overflow-hidden bg-ink" data-id="element-81" data-mp="sg0osjtyek1q">
                  <img src={cluster.image} alt={`AI-assisted OCT segmentation example — ${cluster.name}`} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-82" data-mp="siwke1ibwwn0" />
                  <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-83" data-mp="ni8n4y3ibjkc" />
                  <span className="absolute left-4 top-3 font-display text-[30px] font-bold leading-none tabular-nums text-paper/85" data-id="element-84" data-mp="2hv8bbflydm38">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                <div className="flex flex-1 flex-col px-6 py-5" data-id="element-85" data-mp="27ujkiaejksc">
                  <h3 className="text-[10px] uppercase tracking-micro text-blue" data-id="element-86" data-mp="fyhjuevt9iqj">{cluster.name}</h3>
                  <ul className="mt-4 space-y-2.5" data-id="element-87" data-mp="b6prbyt3h2xr">
                    {detail?.descriptors.map(d => <li key={d} className="border-b border-line pb-2.5 text-[13px] leading-snug text-navy last:border-0" data-id="element-88" data-mp="pvchkvk9ff3r">
                        {d}
                      </li>)}
                  </ul>
                </div>
              </section>;
        })}
        </div>

        <p className="border-t border-line px-9 py-4 text-[11px] leading-relaxed text-mut" data-id="element-89" data-mp="30o6uefpheidf">
          {compareView.note}
        </p>
      </motion.div>
    </motion.div>;
}